import { DownloadIcon, ListIcon, PercentageIcon, SearchIcon } from '@/icons';

const ProHowItWorks = () => {
  const sections: { icon: React.ElementType; title: string; text: string }[] = [
    {
      icon: SearchIcon,
      title: 'Sök och filtrera',
      text: 'Vår databas innehåller unika nyckeltal om bostadsmarknaden. Data finns för hela riket och på läns-, kommun-, stadsdels- och områdesnivå.',
    },
    {
      icon: ListIcon,
      title: 'Jämför',
      text: 'Följ upp hur sålda bostadsprojekt utvecklas relativt successionsmarknaden. Jämför områdesdata med olika tidsperioder eller andra regioner.',
    },
    {
      icon: DownloadIcon,
      title: 'Ladda ner',
      text: 'Exportera statistiken för vidare bearbetning i Excel. Presentera bostadsmarknadsdata på ett pedagogiskt sätt i graf- eller tabellform.',
    },
    {
      icon: PercentageIcon,
      title: 'Analysera',
      text: 'Booli Pro ger dig en inblick i bostadsmarknadsläget och möjliggör spetsiga analyser samt prognoser.',
    },
  ];

  return (
    <div className='flex flex-col'>
      <div className='flex flex-col items-center'>
        <h2 className='font-display tablet:text-3xl mobile:text-2xl text-center text-4xl'>Så fungerar det</h2>
      </div>
      <div className='mt-16'>
        {sections.map((section, i) => (
          <div
            className='flex justify-center'
            key={section.title}
          >
            <div className='mobile:hidden flex w-40 justify-center'>
              <div>
                {<section.icon className={'text-bui-color-orange w-20'} />}
                {i === 3 && <div className='h-14' />}
              </div>
            </div>
            <div className='flex gap-8'>
              <div className='flex flex-col justify-end'>
                <div className='border-bui-color-orange h-full w-full border-l-4' />
                {i === 3 && <div className='bg-bui-color-orange absolute h-4 w-4 self-center rounded-full'></div>}
              </div>
              <div className='mobile:w-full w-96 pb-20'>
                <div className='flex gap-3'>
                  <div
                    className={`bg-bui-color-black font-display text-bui-color-white mb-2 grid h-10 w-10
                    place-items-center rounded-full`}
                  >
                    {i + 1}
                  </div>
                  <h3 className={'font-display mt-2 text-xl'}>{section.title}</h3>
                </div>
                <p>{section.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProHowItWorks;
